import mitt from 'mitt'

type Events = {
  'component:onLoad': { component: any }
  'component:onSave': { component: any }
  'component:onDestroy': { component: any }
  'component:onValueUpdate': { component: any, value: any }
  /** Emitted by the chat stream when an AI resource edit modifies the in-memory draft. */
  'resource:draft-updated': { path: string; content: any[]; blockId?: string }
  /** Emitted by the resource_focus client tool to scroll to and highlight a block. */
  'resource:focus-block': { blockId: string }
  /** Emitted by editor chrome to reveal a selected block in the hierarchy tree. */
  'resource-editor:reveal-in-hierarchy': { id: string }
  /** Emitted by the resource_save client tool to trigger saving. */
  'resource:save-requested': { path: string }
  /** Emitted by automation chat tools after mutating the VueFlow graph. */
  'automation:node-added': { nodeId: string; nodeType?: string; label?: string }
  'automation:node-updated': { nodeId: string }
  'automation:node-removed': { nodeId: string }
} & Record<string, any>; // allow dynamic events like `component:onEdit:${id}`

export const eventBus = mitt<Events>()
